import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // DODANO
import Icon from '../../../components/AppIcon';

const UpdateInfoModal = ({ isOpen, onClose, selectedRow, columns, onSave }) => {
  const { t } = useTranslation(); // HOOK ZA PREVOD
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});

  useEffect(() => {
    if (selectedRow) {
      setEditData(selectedRow);
      setIsEditing(false);
    }
  }, [selectedRow, isOpen]);

  if (!isOpen || !selectedRow) return null;

  const handleInputChange = (col, value) => {
    setEditData(prev => ({ ...prev, [col]: value }));
  };

  const adjustNumber = (col, amount) => {
    const currentRawValue = editData[col];
    const currentVal = (currentRawValue === '' || currentRawValue === null) ? 0 : parseFloat(currentRawValue);
    const safeVal = isNaN(currentVal) ? 0 : currentVal;
    handleInputChange(col, safeVal + amount);
  };

  const handleSaveClick = () => {
    const finalData = { 
      ...editData, 
      created_at: new Date().toISOString() 
    };
    onSave(finalData);
    setIsEditing(false);
  };

  // --- LOGIKA ZA PREPOZNAVANJE TIPOVA ---

  const isNumberColumn = (col) => {
    const val = selectedRow[col];
    if (typeof val === 'boolean') return false;
    return typeof val === 'number' || (!isNaN(parseFloat(val)) && isFinite(val) && !isDateColumn(col));
  };

  const isBooleanColumn = (col) => {
    const val = selectedRow[col];
    return typeof val === 'boolean' || val === 'true' || val === 'false';
  };

  const isDateColumn = (col) => {
    const val = selectedRow[col];
    if (!val || typeof val !== 'string') return false;
    // Provjera za YYYY-MM-DD format (ISO date)
    const dateRegex = /^\d{4}-\d{2}-\d{2}/;
    return dateRegex.test(val) || col.toLowerCase().includes('data') || col.toLowerCase().includes('datum');
  };

  // Pomoćna funkcija da skrati ISO datum na YYYY-MM-DD za input
  const formatForDateInput = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.substring(0, 10);
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-background/90 backdrop-blur-xl animate-in fade-in duration-300">
      <div className="bg-card w-full max-w-2xl rounded-[3rem] border border-border shadow-2xl overflow-hidden animate-in zoom-in-95">
        
        {/* Header */}
        <div className="p-10 border-b border-border/50 flex justify-between items-center bg-muted/20">
          <div>
            <h2 className="text-2xl font-black uppercase tracking-tighter text-foreground">
              {isEditing ? t('update_info.header.edit_title') : t('update_info.header.view_title')}
            </h2>
            <p className="text-[10px] text-primary font-black uppercase tracking-widest mt-1">
              {isEditing ? t('update_info.header.edit_subtitle') : t('update_info.header.view_subtitle')}
            </p>
          </div>
          <div className="flex gap-2">
            {!isEditing && (
              <button 
                onClick={() => setIsEditing(true)}
                className="p-4 bg-primary/10 text-primary hover:bg-primary hover:text-white rounded-2xl transition-all"
              >
                <Icon name="Edit3" size={20} />
              </button>
            )}
            <button onClick={onClose} className="p-4 hover:bg-muted rounded-2xl transition-all">
              <Icon name="X" size={24} />
            </button>
          </div>
        </div>
        
        {/* Body */}
        <div className="p-10 max-h-[60vh] overflow-y-auto custom-scrollbar">
          <div className="space-y-6">
            {columns.map(col => {
              const val = editData[col];
              const isBool = isBooleanColumn(col);
              const isNum = isNumberColumn(col);
              const isDate = isDateColumn(col);
              const isNegative = isNum && parseFloat(val) < 0;

              return (
                <div key={col} className="flex flex-col border-b border-border/30 pb-4">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-[9px] font-black uppercase tracking-widest text-muted-foreground/60">
                      {col.replace(/_/g, ' ')}
                    </span>
                    {isEditing && (
                      <span className="text-[8px] font-black text-primary/40 uppercase">
                        {isBool ? t('update_info.types.boolean') : isDate ? t('update_info.types.date') : isNum ? t('update_info.types.number') : t('update_info.types.text')}
                      </span>
                    )}
                  </div>
                  
                  {isEditing ? (
                    <div className="space-y-2">
                      <div className="flex items-center gap-2">
                        {/* 1. BOOLEAN PREKIDAČ */}
                        {isBool ? (
                          <button 
                            type="button"
                            onClick={() => handleInputChange(col, !val)}
                            className={`w-full flex items-center justify-between px-6 py-4 rounded-2xl border-2 transition-all ${
                              val ? 'bg-primary/10 border-primary text-primary' : 'bg-muted/20 border-border/60 text-muted-foreground'
                            }`}
                          >
                            <span className="text-xs font-black uppercase tracking-widest">
                              {val ? t('update_info.labels.true') : t('update_info.labels.false')}
                            </span>
                            <div className={`w-10 h-6 rounded-full p-1 transition-colors ${val ? 'bg-primary' : 'bg-muted-foreground/30'}`}>
                              <div className={`w-4 h-4 bg-white rounded-full transition-transform ${val ? 'translate-x-4' : 'translate-x-0'}`} />
                            </div>
                          </button>
                        ) : isDate ? (
                          /* 2. DATE INPUT */
                          <div className="relative w-full">
                            <input 
                              type="date"
                              className="w-full bg-background border border-border/60 rounded-xl px-4 py-3 text-sm font-bold outline-none focus:ring-2 focus:ring-primary/20 transition-all"
                              value={formatForDateInput(val)}
                              onChange={(e) => handleInputChange(col, e.target.value)}
                              onClick={(e) => e.target.showPicker && e.target.showPicker()}
                            />
                            <div className="absolute right-4 top-1/2 -translate-y-1/2 text-primary/40 pointer-events-none">
                              <Icon name="Calendar" size={16} />
                            </div>
                          </div>
                        ) : (
                          /* 3. STANDARDNI INPUT (TEXT/NUMBER) */
                          <>
                            {isNum && (
                              <button 
                                onClick={() => adjustNumber(col, -1)}
                                className="p-3 bg-muted hover:bg-destructive/10 hover:text-destructive rounded-xl transition-all"
                              >
                                <Icon name="Minus" size={16} />
                              </button>
                            )}
                            
                            <input 
                              type={isNum ? "number" : "text"}
                              className={`w-full bg-background border rounded-xl px-4 py-3 text-sm font-bold outline-none transition-all ${
                                isNegative ? 'border-destructive/50 focus:ring-destructive/10' : 'border-border/60 focus:ring-primary/20'
                              }`}
                              value={val ?? ''}
                              onChange={(e) => handleInputChange(col, e.target.value)}
                            />

                            {isNum && (
                              <button 
                                onClick={() => adjustNumber(col, 1)}
                                className="p-3 bg-muted hover:bg-primary/10 hover:text-primary rounded-xl transition-all"
                              >
                                <Icon name="Plus" size={16} />
                              </button>
                            )}
                          </>
                        )}
                      </div>
                      
                      {isNegative && (
                        <div className="flex items-center gap-1.5 ml-1 text-destructive animate-in slide-in-from-left-1">
                          <Icon name="AlertCircle" size={12} />
                          <span className="text-[9px] font-black uppercase tracking-tight">{t('update_info.labels.negative_value')}</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    /* PREGLED MOD */
                    <div className="flex items-center gap-2">
                      {isBool ? (
                        <span className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${
                          val ? 'bg-emerald-500/10 text-emerald-600 border border-emerald-500/20' : 'bg-muted text-muted-foreground'
                        }`}>
                          {val ? t('update_info.labels.active') : t('update_info.labels.inactive')}
                        </span>
                      ) : isDate ? (
                        <span className="text-sm font-bold tracking-tight text-foreground flex items-center gap-2">
                          <Icon name="Calendar" size={14} className="text-muted-foreground" />
                          {new Date(val).toLocaleDateString('it-IT')} 
                        </span>
                      ) : (
                        <span className={`text-sm font-bold tracking-tight ${isNegative ? 'text-destructive' : 'text-foreground'}`}>
                          {val || <span className="opacity-20">—</span>}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
            
            <div className="flex flex-col pt-2 opacity-40">
              <span className="text-[9px] font-black uppercase tracking-widest text-muted-foreground/60 mb-1">
                {t('update_info.labels.last_update')}
              </span>
              <span className="text-xs font-bold text-foreground">
                {editData.created_at ? new Date(editData.created_at).toLocaleString('it-IT') : '---'}
              </span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-10 bg-muted/10 border-t border-border/50 flex gap-4">
          {isEditing ? (
            <>
              <button onClick={() => setIsEditing(false)} className="flex-1 py-5 rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-muted transition-all">
                {t('update_info.footer.cancel')}
              </button>
              <button onClick={handleSaveClick} className="flex-[2] py-5 bg-primary text-white rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-xl shadow-primary/30 hover:scale-[1.02] transition-all">
                {t('update_info.footer.save_changes')}
              </button>
            </>
          ) : (
            <button onClick={onClose} className="w-full py-5 bg-foreground text-background rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-xl hover:scale-[1.01] transition-all">
              {t('update_info.footer.close_view')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateInfoModal;